const testIdPrefix = 'parent-profile'

export const testIDs = {
  familyNotes: `${testIdPrefix}-family-notes`,
  studentNotes: `${testIdPrefix}-student-notes`,
}
